import React from 'react';
import './CloseButton.css';

const CloseButton = ({ 
  onClick,
  className = '',
  size = 'medium',
  ...props 
}) => {
  const baseClasses = 'close-btn';
  const sizeClasses = `close-btn-${size}`;
  
  const classes = [baseClasses, sizeClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={classes}
      onClick={onClick}
      {...props}
    >
      <svg className="close-btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  );
};

export default CloseButton;



